// extracted by mini-css-extract-plugin
export default {"subtitleContainer":"Authorization_subtitleContainer__0y2eO","skeletonLoadingAnimation":"Authorization_skeletonLoadingAnimation__4ABMS"};